/**
 * Get the classname
 *
 * @return {string}
 */
export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
